import React, { useEffect, useRef, useState } from 'react';
import Cookies from 'js-cookie';

function Editor({ onChange, name, initData }) {
    const editorRef = useRef();
    const [editorLoaded, setEditorLoaded] = useState(false);
    const { CKEditor, ClassicEditor } = editorRef.current || {};
    const storageUrl = process.env.NEXT_PUBLIC_HOSTNAME + 'files/editor/upload';

    useEffect(() => {
        editorRef.current = {
            CKEditor: require('@ckeditor/ckeditor5-react').CKEditor, // v3+
            ClassicEditor: require('@ckeditor/ckeditor5-build-classic'),
        };

        setEditorLoaded(true);
    }, []);

    class MyUploadAdapter {
        constructor(loader) {
            this.loader = loader;
        }

        // Starts the upload process.
        upload() {
            return this.loader.file.then(
                (file) =>
                    new Promise((resolve, reject) => {
                        this._initRequest();
                        this._initListeners(resolve, reject, file);
                        this._sendRequest(file);
                    })
            );
        }

        // Aborts the upload process.
        abort() {
            if (this.xhr) {
                this.xhr.abort();
            }
        }

        _initRequest() {
            const apiUrl = storageUrl;
            const xhr = (this.xhr = new XMLHttpRequest());
            xhr.open('POST', apiUrl, true);
            xhr.responseType = 'json';
            // let token = localStorage.getItem('auth_token');
            let token = Cookies.set('auth_token');
            xhr.setRequestHeader('Authorization', 'Bearer ' + token);
            xhr.setRequestHeader('Content-Type', 'application/json');
        }
        _initListeners(resolve, reject, file) {
            const xhr = this.xhr;
            const loader = this.loader;
            const genericErrorText = `Couldn't upload file: ${file.name}.`;

            xhr.addEventListener('error', () => reject(genericErrorText));
            xhr.addEventListener('abort', () => reject());
            xhr.addEventListener('load', () => {
                const response = xhr.response;
                // This example assumes the XHR server's "response" object will come with
                // an "error" which has its own "message" that can be passed to reject()
                // in the upload promise.
                //
                // Your integration may handle upload errors in a different way so make sure
                // it is done properly. The reject() function must be called when the upload fails.
                if (response) {
                    if (!response || response.error) {
                        return reject(
                            response && response.error ? response.error.message : genericErrorText
                        );
                    } else {
                        resolve({
                            default: response.url,
                        });
                    }
                }

                // If the upload is successful, resolve the upload promise with an object containing
                // at least the "default" URL, pointing to the image on the server.
                // This URL will be used to display the image in the content. Learn more in the
                // UploadAdapter#upload documentation.
            });

            // Upload progress when it is supported. The file loader has the #uploadTotal and #uploaded
            // properties which are used e.g. to display the upload progress bar in the editor
            // user interface.
            if (xhr.upload) {
                xhr.upload.addEventListener('progress', (evt) => {
                    if (evt.lengthComputable) {
                        loader.uploadTotal = evt.total;
                        loader.uploaded = evt.loaded;
                    }
                });
            }
        }
        _sendRequest(file) {
            let reader = new FileReader();
            const convertBase64 = (fl, rdr) => {
                rdr.readAsDataURL(fl);
                rdr.onerror = () => {

                };
            };
            let base64Image = convertBase64(file, reader);
            // Prepare the form data.
            reader.onload = () => {
                base64Image = reader.result;
                let jsonfile = JSON.stringify({
                    image: base64Image,
                });

                this.xhr.onload = () => {
                    jsonfile = JSON.stringify({
                        image: base64Image,
                    });
                };
                this.xhr.send(jsonfile);
            };
        }
    }

    return (
        <div style={{}}>
            {editorLoaded ? (
                <CKEditor
                    type=""
                    name={name}
                    editor={ClassicEditor}
                    data={initData}
                    onChange={(event, editor) => {
                        const data = editor.getData();
                        onChange(data);
                    }}
                    onReady={(editor) => {
                        editor.plugins.get('FileRepository').createUploadAdapter = (loader) => {
                            return new MyUploadAdapter(loader);
                        };
                    }}
                    config={{
                        mediaEmbed: {
                            previewsInData: true, // Enable previewsInData
                        },
                    }}
                />
            ) : (
                <div>Ачааллаж байна</div>
            )}
        </div>
    );
}

export default Editor;
